import workspaceQuery from '../../../graphql/queries/bank/BankTransferWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/bank/BankTransferQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankTransferDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankTransferMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/bank/SaveBankTransferTempMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankTransferFragment.graphql';

import { formActions } from '../../../actions/bank/BankTransferAction';

const BankTransfer = {
  type: 'BankTransfer',
  title: 'Inter Account Transfers',
  formUrl: '/Bank/Transfer/Details/',
  formTitle: 'Inter Account Transfers',
  workspaceUrl: '/Bank/Transfer/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'BANK_TRANSFER',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'PENDING'],
    },
  ],
};

export default BankTransfer;
